<template>
	<div class="assignment">
		<div class="ass-head">
			<i class="iconfont icon-back" @click="back" title="返回作业列表"></i>
			<ul class="topic-num"
          v-loading.fullscreen.lock="changeLoading || resultLoading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          element-loading-spinner="el-icon-loading"
          element-loading-text="加载中..."
      >
				<!-- <li v-for="(item, index) in list" :key="item.id" :class="index == activeNum?'active':''" -->
				<li v-for="(item, index) in list" :key="item.id" :class="{active: activeNum == index,
					succeed: activeNum != index&& [2,3,4].indexOf(item.user_result) !== -1,
					error: activeNum != index&& [1,6,10,11].indexOf(item.user_result) !== -1}"
					@click="changeSubject(index)">{{ index+1 }}
				</li>
			</ul>
			<div v-show="showSubjectLoding" class="subject-loding">题目加载中，请稍后点击</div>
		</div>
		<div style="height: calc(100% - 3.8rem);overflow: auto;">
			<div class="ass-con" v-if="homeWorkItem">
				<acoj-render ref="acoj" v-if="homeWorkItem.problem_type == 1 || homeWorkItem.problem_type == 7" :problem-info="problemInfo" :allow-copy="allowCopy"
					:user-homework-result="userHomeworkResult" :problem-lang="homeWorkItem.problem_type == 1 ? 1 : 6" @commitResult="commitResult"></acoj-render>
				<!-- <game-render ref="game" v-if="injectJSLoadFinish && homeWorkItem.problem_type == 2" :problem-info="problemInfo"
					:user-homework-result="userHomeworkResult" @commitResult="commitResult"></game-render> -->
        <ai-course-render ref="ai" v-if="homeWorkItem.problem_type == 4" :problem-info="problemInfo"
                     :user-homework-result="userHomeworkResult" @commitResult="commitResult"></ai-course-render>
			<InjectEditorScratchJS @injectJSFinish="injectScratchJSFinish"></InjectEditorScratchJS>
				<!-- scratch作业 -->
				<ScratchRender
            ref="scratchRender"
            v-if="homeWorkItem.problem_type === 5 && showComponent"
            :practice="problemInfo.problem"
            :user-homework-result="userHomeworkResult"
            :gameSpeed="scratchData.ahaSpeed"
            @commitResult="commitResult"
            @changeSpeed="changeSpeed"
        ></ScratchRender>
			</div>
<!--			<div class="ass-foot">-->
<!--				<div class="topic-change topic-last" v-show="activeNum != 0" @click="changeSubject(activeNum-1)">上一题-->
<!--				</div>-->
<!--				<div class="topic-change topic-next" v-show="activeNum != list.length-1"-->
<!--					@click="changeSubject(activeNum+1)">下一题</div>-->
<!--			</div>-->
		</div>
	</div>
</template>

<script>
	// import eventBus from '@/utils/eventBus.js'
	import { getHomeworkList, getHomeworkInfo, getHomeworkResult, commitHomeworkResult } from '@/api/homework'
	import acojRender from "./components/acojRender";
	import aiCourseRender from "./components/aiCourseRender";
	import ScratchRender from "./components/ScratchRender";
	import InjectEditorScratchJS from "./components/InjectEditorScratchJS";
	// 创建 BroadcastChannel 对象
	const eventBus = new BroadcastChannel('eventBus')
	export default {
		name: "assignment",
		components: {
			acojRender,
      'ai-course-render': aiCourseRender,
			ScratchRender,
			InjectEditorScratchJS
		},
		data() {
			return {
				homeworkId: "",
        classId: null,
				list: [], // 作业列表
				activeNum: 0, // 当前第几个作业
				homeWorkItem: null, // 选择的题目
				problemInfo: null, // 题目详情
        allowCopy: true, // 允许复制答案
				userHomeworkResult: null, // 作业结果
				resultTime: 0, // 提交后获取作业次数
				injectJSLoadFinish: false,
				baseLoading: null,
        changeLoading: false,
        resultLoading: false,
				times: 0, // 时间戳
				showSubjectLoding: false,
				isRunningGame: false,
        problemGameType: [2,6,9],
        problemOJType:[1,7],
        problemOtherType: [4,5],
        injectScratchJSLoadFinish: false,
        showComponent: false, // scratch切换题目
        scratchData: {
          ahaSpeed: 1
        }
			}
		},
		created() {
			this.homeworkId = this.$route.query.homeworkId;
			this.classId = this.$route.query.classId;
			eventBus.addEventListener('message', this.handleMessage)
		},
		mounted() {
			this.homeworkList();
		},
		beforeDestroy() {
			// 移除监听
			eventBus.removeEventListener('message', this.handleMessage);
		},
		methods: {
			injectScratchJSFinish(val){
				this.injectScratchJSLoadFinish = val
			},
			handleMessage(event){
				let data = event.data;
				if(data.event === 'submitGame'){
					this.commitResult(data.data);
				} else if (data.event === "runningGame") {
					this.isRunningGame = data.data == 1 ? true : false;
				}
			},

			back() {
        // this.$refs.game.gameQuit()
        // this.$router.go(-1);
        this.baseLoading = this.$loading({
          text: "加载中...",
          spinner: 'el-icon-loading',
          background: "rgba(0, 0, 0, 0.3)"
        });
        if(this.problemGameType.indexOf(this.homeWorkItem.problem_type) !== -1) {
          if(this.isRunningGame){
            this.$message.warning("正在运行游戏，请稍后再切换题目");
            this.baseLoading.close()
            return;
          }
          if(!this.$store.getters.gameLoadingFinish){
            this.$message({
              message: '游戏加载中，请稍后'
            })
            this.baseLoading.close()
            return false
          }
          const that = this

          eventBus.postMessage({
            event: 'show',
            data: {
              isShow: false
            }
          })
          // this.$refs.game.gameQuit(function (){
          that.baseLoading.close()
          that.$router.push({
            name: "classInfo",
            query: {
              classId: that.classId
            }
          })
        }else{
					if(this.homeWorkItem.problem_type === 5 && this.isRunningGame){
            this.$message.warning("正在运行游戏，请稍后再切换题目");
            this.baseLoading.close()
            return;
					}
          this.baseLoading.close()
          this.$router.push({
            name: "classInfo",
            query: {
              classId: this.classId
            }
          })
        }
			},
			// 初始化编程星球
			injectJSFinish: function(val) {
				this.injectJSLoadFinish = val
			},
			homeworkList() { // 获取作业列表
				getHomeworkList({
					classHomeworkId: this.homeworkId
				}).then(res => {
					this.list = res.data.list;
					// console.log("题目列表", JSON.parse(JSON.stringify(this.list)));
					if (this.list.length > 0) {
						this.homeWorkItem = this.list[this.activeNum];
						console.log("当前题目", JSON.parse(JSON.stringify(this.homeWorkItem)));
						this.homeworkInfo();
					}
          this.allowCopy = res.data.allowCopy
				})
			},
			async homeworkInfo() { // 获取题目详情
				const that = this
				let res = await getHomeworkInfo({
					classHomeworkId: this.homeworkId,
					classHomeworkItemId: this.homeWorkItem.id
				})

				if(res.status == 1){
					this.problemInfo = res.data;
					console.log("题目详情", JSON.parse(JSON.stringify(this.problemInfo)));
					this.userHomeworkResult = null;
					if (res.data.resultId) {
						that.homeworkResult(res.data.resultId);
					}
          if(this.problemGameType.indexOf(this.problemInfo.homeworkItemInfo.problem_type) !== -1) {// 游戏
            if(this.problemInfo.homeworkItemInfo.problem_type !== 9) {
              const lang = this.problemInfo.homeworkItemInfo.problem_type === 2?1:6
              eventBus.postMessage({
                event: 'changeLang',
                data: {
                  lang: lang
                }
              })
              eventBus.postMessage({
                event: 'problemInfo',
                data: {
                  problemInfo: this.problemInfo,
                  isShow: true
                }
              })
            }else{
              eventBus.postMessage({
                event: 'gameLoadGameEditorScene',
                data: {
                  problemInfo: this.problemInfo,
                  isShow: true
                }
              })
            }
          }else{
            eventBus.postMessage({
              event: 'show',
              data: {
                isShow: false
              }
            })
            if(this.problemInfo.homeworkItemInfo.problem_type === 5){ // scratch
              this.showComponent = false;
              this.$nextTick(() => {
                this.showComponent = true;
              });
            }
          }
				}
			},
			async homeworkResult(resultId) { // 获取题目结果
			  this.resultLoading = true
        let res
        try {
          res = await getHomeworkResult({
            classHomeworkId: this.homeworkId,
            classHomeworkItemId: this.homeWorkItem.id,
            resultId: resultId
          })
        }catch (error){
			    try {
            res = await getHomeworkResult({
              classHomeworkId: this.homeworkId,
              classHomeworkItemId: this.homeWorkItem.id,
              resultId: resultId,
              showContent: 0
            })
          }catch (error){
            res = {
              data:{
                status: 2,
                result: {},
              }
            }
          }
        }

				if (res.data.status === 2) {
					if (this.baseLoading) this.baseLoading.close();
					this.userHomeworkResult = res.data;
					if(res.data.result.problem_type === 2 || res.data.result.problem_type === 6){
						eventBus.postMessage({
							event: 'homeworkResult',
							data: {
								homeworkResult: this.userHomeworkResult,
								isShow: true
							}
						})
					}
					// 提交代码后修改题目状态
					let nowSubject = this.list[this.activeNum];
          nowSubject.user_result = res.data.result.result;
					if(this.homeWorkItem.problem_type === 4 || this.homeWorkItem.problem_type === 9){
            nowSubject.user_result = res.data.result.result !== 0 ? 4 :0
          }
				} else {
					setTimeout(_ => {
						if (this.resultTime > 120) {
							if (this.baseLoading) this.baseLoading.close();
							this.$message.error("运行失败！");
						} else {
							this.homeworkResult(resultId);
							this.resultTime++;
						}
					}, 4000);
				}
        this.resultLoading = false
			},
			async commitResult({ codeContent, language, result }) { // 提交作业
			  const data = {
					classHomeworkId: this.homeworkId,
					classHomeworkItemId: this.homeWorkItem.id,
					source: codeContent,
					language: language
				}
				if (this.problemOJType.indexOf(this.homeWorkItem.problem_type) === -1) data.result = result;
        // console.log(data, '***************代码测试')
				let res = await commitHomeworkResult(data);
				if (res.status === 1) {
				  switch (this.homeWorkItem.problem_type){
				    case 1:
				    case 7:
              this.baseLoading = this.$loading({
                text: "正在运行代码...",
                spinner: 'el-icon-loading',
                background: "rgba(0, 0, 0, 0.3)"
              });
              setTimeout(_ => {
                this.resultTime = 0;
                this.homeworkResult(res.data.rid);
              }, 4000)
              break;
            case 2:
            case 6:
            case 9:
              let nowSubject = this.list[this.activeNum];
              if([1,2,3,4,6,10,11].indexOf(result) !== -1){
                nowSubject.user_result = result;
              }
              break;
            case 4:
              this.homeworkResult(res.data.rid);
              break;
            case 5:
              this.homeworkResult(res.data.rid);
              break;
          }
				} else {
					this.$message.error(res.message);
				}
			},
			preventChangeSubject() {
				let timeDifference = new Date().getTime() - this.times;
				if (timeDifference <= 2000) {
					this.showSubjectLoding = true;
					setTimeout(_ => {
						this.showSubjectLoding = false;
					}, 2000 - timeDifference)
					return true;
				}
				this.times = new Date().getTime();
				return false
			},
			changeSubject(index) { // 切换题目
				if(this.isRunningGame){
					this.$message.warning("正在运行游戏，请稍后再切换题目");
					return;
				}
				if (this.preventChangeSubject()) return;

				if(this.problemGameType.indexOf(this.homeWorkItem.problem_type) !== -1 && index != this.activeNum){
					eventBus.postMessage({
            event: 'show',
						data: {
              isShow: false
            }
					})
				}

        if (this.$refs.game && this.$refs.game.gameSceneLoading) {
          return false
        }

        if(this.$refs.game){
          this.$refs.game.gameStatus = 3
        }

        if (index === this.activeNum) {
          return false
        }
				this.activeNum = index;

				if(this.homeWorkItem.problem_type === 5){ // 解决scratch积木块输入框不会消失问题
				  const element = document.querySelector('.blocklyWidgetDiv.fieldTextInput');
				  if (element) {
				    element.innerHTML = '';
				    element.classList.remove("fieldTextInput");
						element.removeAttribute('style');
				  }
				}

        const that = this

        if(this.problemOJType.indexOf(that.homeWorkItem.problem_type) !== -1 || this.problemGameType.indexOf(that.list[index].problem_type) !== -1) {
          that.homeWorkItem = that.list[that.activeNum];
          that.homeworkInfo();
          that.changeLoading = false
        }else{
          if(this.problemOJType.indexOf(that.list[index].problem_type) !== -1) {
            this.userHomeworkResult = null
            that.homeWorkItem = that.list[that.activeNum];
            that.homeworkInfo();
            that.changeLoading = false
          }else if(this.problemOtherType.indexOf(that.list[index].problem_type) !== -1) {
            that.homeWorkItem = that.list[that.activeNum];
            that.homeworkInfo();
            that.changeLoading = false
          }
        }
			},
      changeSpeed(e){
        this.scratchData.ahaSpeed = parseInt(e);
        this.showComponent = false;
        this.$nextTick(() => {
          this.showComponent = true;
        });
      }
		}
	}
</script>

<style lang="scss" scoped>
	.assignment {
		width: 100%;
		height: 100%;
		position: relative;
		background: url(~@/assets/img/mainBg.png) no-repeat;
		background-size: 100% 100%;

		.ass-head {
			height: 3.8rem;
			background-color: #252629;
			border-bottom: 0.4rem solid #203B4D;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 1.6rem;
			position: relative;

			.icon-back {
				font-size: 1.68rem;
				cursor: pointer;
				color: #FFF;
				margin-left: 0.4rem;
			}

			.topic-num {
        //width: 100%;
        //height: 80px;
        //white-space: nowrap;
        //overflow-x: scroll;
        //line-height: 70px;
				li {
					display: inline-block;
					width: 1.6rem;
					height: 1.6rem;
					text-align: center;
					line-height: 1.6rem;
					color: #FFF;
					font-size: 0.72rem;
					background-color: #748C9A;
					border-radius: 50%;
					margin-left: 0.6rem;
					cursor: pointer;
					user-select: none;
				}

				li.active {
					background-color: #35EAFF;
				}

				li.succeed {
					background-color: #67c23a;
				}

				li.error {
					background-color: #F56C6C;
				}
			}

			.subject-loding{
				position: absolute;
				color: #FF4848;
				font-size: 0.6rem;
				font-weight: bold;
				right: 1.6rem;
				bottom: 0;
				line-height: 1.6;
			}
		}

		.ass-con {
			min-height: 12rem;
			padding: 0.8rem;
			height: calc(100% - 4.6rem);
		}

		.ass-foot {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-bottom: 0.8rem;

			.topic-change {
				width: 11.2rem;
				height: 3.04rem;
				background: url(~@/assets/img/switchTopic.png) no-repeat;
				text-align: center;
				line-height: 3.04rem;
				font-size: 1.12rem;
				color: #FFF;
				cursor: pointer;
				margin: 0 2.2rem;
				user-select: none;
			}

			.topic-last {}

			.topic-next {}
		}
	}
</style>
